import { render, staticRenderFns } from "./mark-purpose.vue?vue&type=template&id=5853c320&"
import script from "./mark-purpose.vue?vue&type=script&lang=js&"
export * from "./mark-purpose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports